import { formatInTimeZone } from "date-fns-tz";

export const formatDate = (date: Date): string =>
  `${formatInTimeZone(date, "UTC", "LLL d, HH:mm")} UTC`;
